import { useEffect } from "react";
import { SupportingFooter, SupportingHeader } from "./SupportingChrome";
import "../../supporting-world.css";

export default function SupportingStatusPage() {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Page not found — The Gift Conversation";
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="tgc-world-shell tgc-world-shell--read tgc-supporting">
      <div className="tgc-supporting-backdrop" aria-hidden="true" />
      <SupportingHeader />

      <main className="tgc-supporting-page" aria-labelledby="tgc-supporting-title">
        <div className="tgc-supporting-mark" aria-hidden="true" />
        <h1 id="tgc-supporting-title">This page isn’t here.</h1>
        <p>The link may be incomplete or no longer available.</p>
        <a className="tgc-world-button tgc-world-button--primary tgc-supporting-home" href="/">
          Return to The Gift Conversation
        </a>
      </main>

      <SupportingFooter />
    </div>
  );
}
